
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ARHa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6fc1209684233dbf$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd33b381dded5ef628eed8716924678b>>
 * @codegenCommand yarn build tokens
 */ var $6fc1209684233dbf$export$2e2bcd8739ae039 = "\nhtml[data-theme~=\"shape:shape\"], [data-subtree-theme][data-theme~=\"shape:shape\"] {\n  --ds-radius-xsmall: 0.125rem;\n  --ds-radius-small: 0.25rem;\n  --ds-radius-medium: 0.375rem;\n  --ds-radius-large: 0.5rem;\n  --ds-radius-xlarge: 0.75rem;\n  --ds-radius-xxlarge: 1rem;\n  --ds-radius-full: 624.9375rem;\n  --ds-radius-tile: 25%;\n  --ds-border-width: 0.0625rem;\n  --ds-border-width-selected: 0.125rem;\n  --ds-border-width-focused: 0.125rem;\n}\n";

});


//# sourceMappingURL=atlassian-shape.202c8cf5.js.map
